<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">検索条件設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <wj-tab-panel id="tab_KYMW0300" #tab_KYMW0300 creationPolicy="all"
          [(selectedIndex)]="kymw0300Model.tabSelectedIndex" [tabindex]="-1">
          <wj-tab>
            <a>通常検索</a>
            <div class="accordion-area">
              <div class="element-column">
                <wj-accordion #wad_goods [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
                  (initialized)="initCollapsed(wad_goods, false)">
                  <wj-accordion-pane>
                    <div>商品関連条件</div>
                    <div>
                      <div class="element-column">
                        <div class="block-row">
                          <div class="column-list">
                            <label class="list-input-title">Ｐコード</label>
                            <div class="list-input-content">
                              <input type="text" id="tbx_PCode" #tbx_PCode [(ngModel)]="kymw0300Model.pcode"
                                plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8" [autofocus]="true"
                                forcedEnabledMode="true" [tabindex]="0" class="pcode" />
                            </div>

                            <label class="list-input-title">JANコード</label>
                            <div class="list-input-content">
                              <input type="text" id="tbx_JANCode" [tabindex]="0" forcedEnabledMode="true"
                                [maxlength]="13" plessInputTextSub [restrict]="'[0-9]'"
                                [(ngModel)]="kymw0300Model.janCode" class="jan-code" />
                            </div>

                            <label class="list-input-title">商品案内用商品名</label>
                            <div class="list-input-content">
                              <app-text-input id="tbx_GuideGoodsName" #tbx_GuideGoodsName [subid]="'tbx_GuideGoodsName'"
                                [fullOnly]="true" [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false"
                                [(ngModel)]="kymw0300Model.guideGoodsName" [forcedEnabledMode]="'true'"
                                class="guide-goods-name" [maxChars]="30">
                              </app-text-input>
                            </div>
                          </div>

                          <div class="column-list">
                            <label class="list-input-title">アイテムコード</label>
                            <div class="list-input-content">
                              <input type="text" id="tbx_ItemCode" [tabindex]="0" forcedEnabledMode="true"
                                [maxlength]="7" plessInputTextSub [restrict]="'[0-9]'"
                                [(ngModel)]="kymw0300Model.itemCode" class="item-code" />
                            </div>

                            <label class="list-input-title">メーカー名</label>
                            <div class="list-input-content">
                              <app-text-input id="tbx_MakerName" #tbx_MakerName [subid]="'tbx_MakerName'"
                                [fullOnly]="true" [restrict]="'[ -￮]'" [maxChars]="30" [tabindex]="0"
                                [displayCountField]="false" [(ngModel)]="kymw0300Model.makerName"
                                [forcedEnabledMode]="'true'" [width]="'36rem'">
                              </app-text-input>
                            </div>

                            <label class="list-input-title">商品案内用規格名</label>
                            <div class="list-input-content">
                              <app-text-input id="tbx_GuideStandardName" #tbx_GuideStandardName
                                [subid]="'tbx_GuideStandardName'" [fullOnly]="true" [restrict]="'[ -￮]'" [tabindex]="0"
                                [displayCountField]="false" [(ngModel)]="kymw0300Model.guideStandardName"
                                [forcedEnabledMode]="'true'" [width]="'36rem'" [maxChars]="30">
                              </app-text-input>
                            </div>
                          </div>
                        </div>

                        <div class="column-list">
                          <div class="list-input-title">タグ</div>
                          <div class="list-input-content">
                            <div class="tag-list-container">
                              <ng-template ngFor let-item [ngForOf]="kymw0300Model.tagOutput" let-i="index">
                                <div class="chip">
                                  {{item.tagName}}
                                  <span class="closebtn" (click)="removeTag(item.tagId, 'tag')">&times;</span>
                                </div>
                              </ng-template>
                            </div>
                            <div class="element-column">
                              <div class="mark-count-field">
                                <div>{{tagLength}}</div><div>個/30個</div>
                              </div>
                              <div class="element-row" style="align-items: center;">
                                <button id="btn_SelectTag" [tabindex]="0" class="btn-secondary" forcedEnabledMode="true"
                                  (click)="eventSelectTagHandler()">選択</button>
                                <app-radio-label [label]="'AND検索'" id="rdb_TagSearchType0" #rdb_TagSearchType0
                                  [subid]="'rdb_TagSearchType0'" [forcedEnabledMode]="'true'" [tabindex]="0"
                                  [name]="'tagradiogroup'" value="AND" [(ngModel)]="kymw0300Model.tagSearchType">
                                </app-radio-label>
                                <app-radio-label label="OR検索" id="rdb_TagearchType1" #rdb_TagSearchType1
                                  [subid]="'rdb_TagSearchType1'" [forcedEnabledMode]="'true'" [tabindex]="0"
                                  [name]="'tagradiogroup'" value="OR" [(ngModel)]="kymw0300Model.tagSearchType">
                                </app-radio-label>
                              </div>
                            </div>
                          </div>
                          <div class="list-input-title">商品マーク</div>
                          <div class="list-input-content">
                            <div class="tag-list-container">
                              <ng-template ngFor let-item [ngForOf]="kymw0300Model.goodsMarkOutput" let-i="index">
                                <div class="chip">
                                  {{item.markCode}}：{{item.markName}}
                                  <span class="closebtn" (click)="removeTag(item.markCode, 'goodsMark')">&times;</span>
                                </div>
                              </ng-template>
                            </div>
                            <div class="element-column">
                              <div class="mark-count-field">
                                <div>{{goodsMarkLength}}</div><div>個/30個</div>
                              </div>
                              <div class="element-row" style="align-items: center;">
                                <button id="btn_SelectGoodsMark" [tabindex]="0" class="btn-secondary"
                                  forcedEnabledMode="true" (click)="eventSelectGoodsMarkHandler()">選択</button>
                                <app-radio-label label="AND検索" id="rdb_GoodsMarkSearchSType0" #rdb_GoodsMarkSearchType0
                                  [subid]="'rdb_GoodsMarkSearchType0'" [name]="'goodsmarkradiogroup'"
                                  [forcedEnabledMode]="'true'" [tabindex]="0"
                                  [(ngModel)]="kymw0300Model.goodsMarkSearchType" value="AND"></app-radio-label>
                                <app-radio-label label="OR検索" id="rdb_GoodsMarkSearchType1" #rdb_GoodsMarkSearchType1
                                  [subid]="'rdb_GoodsMarkSearchType1'" [name]="'goodsmarkradiogroup'"
                                  forcedEnabledMode="'true'" [tabindex]="0" [(ngModel)]="kymw0300Model.goodsMarkSearchType"
                                  value="OR"></app-radio-label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="block-row">
                          <div class="column-list" style="width: 400px;">
                            <div class="list-input-title">取扱終了商品</div>
                            <div class="list-input-content">
                              <app-checkbox-label id="chk_KbnFlg" #chk_KbnFlg forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw0300Model.dataKbnFlg" label="含む"></app-checkbox-label>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title">ダミー商品</label>
                            <div class="list-input-content">
                              <app-checkbox-label id="chk_DummyGoods" [subid]="'chk_DummyGoods'" [tabindex]="0"
                                [forcedEnabledMode]="'true'"
                                [(ngModel)]="kymw0300Model.dummyGoodsSelected"></app-checkbox-label>
                            </div>
                          </div>
                        </div>
                        <div class="column-list">
                          <label class="list-input-title">取扱可能生協</label>
                          <div class="list-input-content">
                            <app-checkbox-label label="ALL" id="chk_AllCoop" #chk_AllCoop forcedEnabledMode="true"
                              [tabindex]="0" (change)="eventAllCoop_CLICKHandler()"
                              [(ngModel)]="kymw0300Model.allCoop"></app-checkbox-label>
                            <app-checkbox-label label="い" id="chb_Seikyou1" [subid]="'chb_Seikyou1'" [tabindex]="0"
                              [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.seikyou1Selected"
                              (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
                            <app-checkbox-label label="と" id="chb_Seikyou2" [subid]="'chb_Seikyou2'" [tabindex]="0"
                              [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.seikyou2Selected"
                              (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
                            <app-checkbox-label label="ぐ" id="chb_Seikyou3" [subid]="'chb_Seikyou3'" [tabindex]="0"
                              [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.seikyou3Selected"
                              (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
                            <app-checkbox-label label="ち" id="chb_Seikyou4" [subid]="'chb_Seikyou4'" [tabindex]="0"
                              [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.seikyou4Selected"
                              (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
                            <app-checkbox-label label="さ" id="chb_Seikyou5" [subid]="'chb_Seikyou5'" [tabindex]="0"
                              [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.seikyou5Selected"
                              (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
                            <app-checkbox-label label="とう" id="chb_Seikyou6" [subid]="'chb_Seikyou6'" [tabindex]="0"
                              [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.seikyou6Selected"
                              (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
                            <app-checkbox-label label="な" id="chb_Seikyou7" [subid]="'chb_Seikyou7'" [tabindex]="0"
                              [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.seikyou7Selected"
                              (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
                            <app-checkbox-label label="に" id="chb_Seikyou8" [subid]="'chb_Seikyou8'" [tabindex]="0"
                              [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.seikyou8Selected"
                              (change)="eventSeikyou_CLICKHandler()"></app-checkbox-label>
                          </div>
                        </div>
                        <div class="block-row">
                          <div class="column-list">
                            <label class="list-input-title">バイヤーコード</label>
                            <div class="list-input-content">
                              <app-code-combo-box id="cmb_BuyerCode" #cmb_BuyerCode [subid]="'cmb_BuyerCode'"
                                [(ngModel)]="kymw0300Model.buyerCode" [codeDiv]="'ct357'" [labelField]="'codeValueName'"
                                [autofocus]="true" [forcedEnabledMode]="'true'" [tabindex]="0" [width]="255.5">
                              </app-code-combo-box>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title">登録レベル</label>
                            <div class="list-input-content">
                              <app-code-combo-box id="cmb_admitStatus" #cmb_admitStatus [subid]="'cmb_admitStatus'"
                                [(ngModel)]="kymw0300Model.admitStatus" [codeDiv]="'ctp322'" [labelField]="'CodeName'"
                                [autofocus]="true" [forcedEnabledMode]="'true'" [tabindex]="0" [width]="180" [blank]="false">
                              </app-code-combo-box>
                            </div>
                          </div>
                        </div>
                        <div class="column-list">
                          <div class="list-input-title">マスタ登録日</div>
                          <div class="list-input-content">
                            <wj-input-date id="dtf_StartRegistDate" #dtf_StartRegistDate forcedEnabledMode="true"
                              [tabindex]="0" [isRequired]="false" [(text)]="kymw0300Model.registDateFrom">
                            </wj-input-date>
                            <label>～</label>
                            <wj-input-date id="dtf_EndRegistDate" #dtf_EndRegistDate forcedEnabledMode="true"
                              [tabindex]="0" [isRequired]="false" [(text)]="kymw0300Model.registDateTo">
                            </wj-input-date>
                          </div>
                          <div class="list-input-title">マスタ更新日</div>
                          <div class="list-input-content">
                            <wj-input-date id="dtf_StartUpdateDate" #dtf_StartUpdateDate forcedEnabledMode="true"
                              [tabindex]="0" [isRequired]="false" [(text)]="kymw0300Model.updateDateFrom">
                            </wj-input-date>
                            <label>～</label>
                            <wj-input-date id="dtf_EndUpdateDate" #dtf_EndUpdateDate forcedEnabledMode="true"
                              [tabindex]="0" [isRequired]="false" [(text)]="kymw0300Model.updateDateTo">
                            </wj-input-date>
                          </div>
                        </div>
                      </div>
                    </div>
                  </wj-accordion-pane>
                </wj-accordion>


                <wj-accordion #wad_class [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
                  (initialized)="initCollapsed(wad_class)">
                  <wj-accordion-pane>
                    <div>部門分類条件</div>
                    <div>
                      <div class="column-list" style="width: 660px;">
                        <label class="list-input-title">部門</label>
                        <div class="list-input-content">
                          <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode" [subid]="'cmb_ClassCode'"
                            [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="true"
                            [(ngModel)]="kymw0300Model.classCode">
                          </app-class-code-combo-box>
                        </div>
                        <label class="list-input-title">中分類</label>
                        <div class="list-input-content">
                          <app-middle-class-code-combo-box #cmb_MiddleClassification id="cmb_MiddleClassification"
                            [subid]="'cmb_MiddleClassification'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [blank]="true" [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="false"
                            [classCode]="cmb_ClassCode.selectedClassCode"
                            [(ngModel)]="kymw0300Model.middleClassCode"></app-middle-class-code-combo-box>
                        </div>
                        <label class="list-input-title">小分類</label>
                        <div class="list-input-content">
                          <app-small-class-code-combo-box #cmb_SmallClassification id="cmb_SmallClassification"
                            [subid]="'cmb_SmallClassification'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [blank]="true" [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="false"
                            [classCode]="cmb_ClassCode.selectedClassCode"
                            [middleClassCode]="cmb_MiddleClassification.selectedMiddleClassCode"
                            [(ngModel)]="kymw0300Model.smallClassCode">
                          </app-small-class-code-combo-box>
                        </div>
                      </div>
                    </div>
                  </wj-accordion-pane>
                </wj-accordion>
                <wj-accordion #wad_supplier [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
                  (initialized)="initCollapsed(wad_supplier)">
                  <wj-accordion-pane>
                    <div>取引先関連条件</div>
                    <div>
                      <div class="element-column">
                        <div class="block-row">
                          <div class="column-list">
                            <label class="list-input-title">発注先コード</label>
                            <div class="list-input-content">
                              <input type="text" id="tbx_OrdrClientCode" [tabindex]="0" forcedEnabledMode="true"
                                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" [style.width.rem]="7"
                                [(ngModel)]="kymw0300Model.ordrClientCode" />
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title">発注先名</label>
                            <div class="list-input-content">
                              <app-text-input id="tbx_OrdrClientKanji" #tbx_OrdrClientKanji
                                [subid]="'tbx_OrdrClientKanji'" [restrict]="'[ -￮]'" [tabindex]="0"
                                [displayCountField]="false" [(ngModel)]="kymw0300Model.ordrClientKanji"
                                [forcedEnabledMode]="'true'" [width]="'32rem'" [maxChars]="30">
                              </app-text-input>
                            </div>
                          </div>
                          <button id="btn_SearchOrdrClient" [tabindex]="0" class="btn-secondary"
                            forcedEnabledMode="true" (click)="eventSearchOrdrClientHandler(null)">検索</button>
                        </div>
                        <div class="block-row">
                          <div class="column-list">
                            <label class="list-input-title">支払先コード</label>
                            <div class="list-input-content">
                              <input type="text" id="tbx_PayeeClientCode" [tabindex]="0" forcedEnabledMode="true"
                                plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" [style.width.rem]="7"
                                [(ngModel)]="kymw0300Model.payeeClientCode" [disabled]="isSupplier"/>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title">支払先名</label>
                            <div class="list-input-content">
                              <app-text-input id="tbx_PayeeClientKanji" #tbx_PayeeClientKanji
                                [subid]="'tbx_PayeeClientKanji'" [restrict]="'[ -￮]'" [tabindex]="0"
                                [displayCountField]="false" [(ngModel)]="kymw0300Model.payeeClientKanji"
                                [forcedEnabledMode]="'true'" [width]="'32rem'" [maxChars]="30" [disabled]="isSupplier">
                              </app-text-input>
                            </div>
                          </div>
                          <button id="btn_SearchPayeeClient" [tabindex]="0" class="btn-secondary"
                            forcedEnabledMode="true" (click)="eventSearchPayeeHandler(null)" [disabled]="isSupplier">検索</button>
                        </div>
                      </div>
                    </div>
                  </wj-accordion-pane>
                </wj-accordion>
                <wj-accordion #wad_plan *ngIf="kymw0300Model.catalogConditionVisible !== 'hidden'" [isAnimated]="false"
                  [allowCollapseAll]="true" [allowExpandMany]="true" (initialized)="initCollapsed(wad_plan)">
                  <wj-accordion-pane>
                    <div>企画関連条件</div>
                    <div>
                      <div class="element-column">
                        <div class="column-list">
                          <label class="list-input-title">媒体</label>
                          <div class="list-input-content">
                            <app-vmedium-type-combo-box [width]="'460px'" id="cmb_MediumType" #cmb_MediumType
                              [subid]="'cmb_MediumType'" [(ngModel)]="kymw0300Model.mediumType" [tabindex]="0"
                              (change)="eventMediumType_CHANGEHandler()" [forcedEnabledMode]="'true'">
                            </app-vmedium-type-combo-box>
                          </div>
                        </div>
                        <div class="block-row">
                          <div class="column-list">
                            <label class="list-input-title">受注コード</label>
                            <div class="list-input-content">
                              <app-order-text-with-catalog #txti_OrderCode [autofocus]="true" [tabindex]="0"
                                [forcedEnabledMode]="'true'" [(ngModel)]="this.kymw0300Model.orderCode" width="150"
                                (onChangedCatalogId)="this.kymw0300Model.catalogId = $event"
                                (ngModelChange)="eventOrderCode_CHANGEHandler()">
                              </app-order-text-with-catalog>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title">企画回</label>
                            <div class="list-input-content">
                              <app-catalog-text-with-order #txti_CatalogId [autofocus]="true" [tabindex]="0"
                                [forcedEnabledMode]="'true'" [(ngModel)]="kymw0300Model.catalogId" width="150"
                                (onChangedOrderCode)="kymw0300Model.orderCode = $event"
                                (ngModelChange)="eventOrderCode_CHANGEHandler()">
                              </app-catalog-text-with-order>
                            </div>
                          </div>
                        </div>
                        <div class="column-list">
                          <label class="list-input-title">特集コード</label>
                          <div class="list-input-content" style="width: 38rem;">
                            <select id="cmb_specialFeature" #cmb_specialFeature labelField="SpecialFeature"
                              [(ngModel)]="kymw0300Model.specialFeature"
                              [disabled]="kymw0300Model.disabledspecialFeatureFlg" forcedEnabledMode="true"
                              [tabindex]="0">
                              <option value=""></option>
                              <ng-template ngFor let-item [ngForOf]="kymw0300Model.specialFeatureList">
                                <option value="{{item.featureCode}}">{{item.featureCode}}：{{item.featureName}}</option>
                              </ng-template>
                            </select>
                          </div>
                          <div class="list-input-title">企画マーク</div>
                          <div class="list-input-content">
                            <div class="tag-list-container" [ngStyle]="getDisabledStyle()">
                              <ng-template ngFor let-item [ngForOf]="kymw0300Model.catalogMarkOutput" let-i="index">
                                <div class="chip">
                                  {{item.markCode}}：{{item.markName}}
                                  <span class="closebtn"
                                    (click)="removeTag(item.markCode, 'catalogMark')">&times;</span>
                                </div>
                              </ng-template>
                            </div>
                            <div class="element-column">
                              <div class="mark-count-field">
                                <div>{{catalogMarkLength}}</div><div>個/30個</div>
                              </div>
                              <div class="element-row" style="align-items: center;">
                                <button id="btn_SelectCatalogMark" [tabindex]="0" class="btn-secondary"
                                  forcedEnabledMode="true" (click)="eventSelectCatalogMarkHandler()"
                                  [disabled]="kymw0300Model.disabledCatalogMarkFlg">選択</button>
                                <app-radio-label label="AND検索" id="rdb_CatalogMarkSearchSType0"
                                  #rdb_CatalogMarkSearchType0 [subid]="'rdb_CatalogMarkSearchType0'"
                                  [name]="'catalogsmarkradiogroup'" forcedEnabledMode="none" [tabindex]="0"
                                  [(ngModel)]="kymw0300Model.catalogMarkSearchType" value="AND"
                                  [disabled]="kymw0300Model.disabledCatalogMarkFlg"></app-radio-label>
                                <app-radio-label label="OR検索" id="rdb_CatalogMarkSearchType1"
                                  #rdb_CatalogMarkSearchType1 [subid]="'rdb_CatalogMarkSearchType1'"
                                  [name]="'catalogmarkradiogroup'" forcedEnabledMode="none" [tabindex]="0"
                                  [(ngModel)]="kymw0300Model.catalogMarkSearchType" value="OR"
                                  [disabled]="kymw0300Model.disabledCatalogMarkFlg"></app-radio-label>
                              </div>
                            </div>
                          </div>
                          <label class="list-input-title" #lbl_PageNo>ページＮＯ</label>
                          <div class="list-input-content">
                            <input type="text" [style.width.px]="710" id="txti_PageNo" #txti_PageNo
                              [disabled]="kymw0300Model.disabledPageNoFlg" [maxlength]="100" plessInputTextSub
                              [restrict]="'[0-9,-]'" [(ngModel)]="kymw0300Model.pageInput" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </wj-accordion-pane>
                </wj-accordion>

                <wj-accordion #wad_duties [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
                  (initialized)="initCollapsed(wad_duties)">
                  <wj-accordion-pane>
                    <div>業態区分条件</div>
                    <div>
                      <div class="column-list">
                        <label id="lbl_DutiesFormDaily" class="list-input-title">デイリー</label>
                        <div class="list-input-content">
                          <app-code-check-box-list [codeDiv]="'ctp123'" [invalidCode]="'00'" id="lst_DutiesFormDaily"
                            #lst_DutiesFormDaily [subid]="'lst_DutiesFormDaily'" [tabindex]="0"
                            [forcedEnabledMode]="'true'" rendererIsEditor="true">
                          </app-code-check-box-list>
                        </div>
                      </div>
                    </div>
                  </wj-accordion-pane>
                </wj-accordion>
              </div>
            </div>
          </wj-tab>

          <wj-tab>
            <a>リスト検索（Ｐコード）</a>
            <div class="input_vertical list_search">
              <div class="layout_balance">
                <label class="list-input-title">Ｐコードリスト</label>
                <app-checkbox-label id="chk_KbnFlgPcodeList" #chk_KbnFlgPcodeList forcedEnabledMode="true" [tabindex]="0"
                  [(ngModel)]="kymw0300Model.dataKbnFlg_pcodeList" label="取扱終了商品を含む">
                </app-checkbox-label>
              </div>
              <div class="element-row">
                <textarea id="txta_PcodeList" #txta_PcodeList forcedEnabledMode="true" plessInputTextSub
                  [restrict]="'[P0-9\n]'" wordWrap="true" [(ngModel)]="kymw0300Model.pcodeList"
                  class="pcode text-label-required" [maxlength]="9000"></textarea>
                <div class="element-column">
                  <label>{{pcodeCount}}件/1000件</label>
                  <label>・１行１件のＰコードを入力してください。</label>
                  <label>・一度に入力できるＰコードは最大1000件までとします。</label>
                </div>
              </div>
            </div>
          </wj-tab>

          <wj-tab>
            <a>リスト検索（アイテムコード）</a>
            <div class="input_vertical list_search">
              <div class="layout_balance">
                <label class="list-input-title">アイテムコードリスト</label>
                <app-checkbox-label id="chk_KbnFlgItemCodeList" #chk_KbnFlgItemCodeList forcedEnabledMode="true" [tabindex]="0"
                  [(ngModel)]="kymw0300Model.dataKbnFlg_itemCodeList" label="取扱終了商品を含む">
                </app-checkbox-label>
              </div>
              <div class="element-row">
                <textarea id="txta_ItemcodeList" #txta_ItemcodeList forcedEnabledMode="true" plessInputTextSub
                  [restrict]="'[0-9\n]'" wordWrap="true" [(ngModel)]="kymw0300Model.itemcodeList"
                  (blur)="itemcodeListPaddingZero()" class="item-code text-label-required"
                  [maxlength]="9000"></textarea>
                <div class="element-column">
                  <label>{{itemcodeCount}}件/1000件</label>
                  <label>・１行１件のアイテムコードを入力してください。</label>
                  <label>・一度に入力できるアイテムコードは最大1000件までとします。</label>
                </div>
              </div>
            </div>
          </wj-tab>
        </wj-tab-panel>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_ConditionClear" class="btn-tartiary" (click)="eventConditionClearHandler(null)"
            forcedEnabledMode="true" [tabindex]="0">クリア</button>
          <button id="btn_CreateTargetList" class="btn-primary" (click)="eventCreateTargetListHandler()"
            forcedEnabledMode="true" [tabindex]="0">検索</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>